import Stack from '@oberoninternal/travelbase-website/dist/components/Stack';
import Button from '@oberoninternal/travelbase-ds/components/action/Button';
import { Box, Flex } from '@rebass/grid';
import { FormattedMessage } from 'react-intl';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import Image from 'next/image';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import { Locale } from '@oberoninternal/travelbase-website/dist/entities/Locale';

const ConfirmExtras = () => {
    const experienceUrls: Record<Locale, string> = {
        nl: '/nl/zien-en-doen/tickets/?utm_source=TicketsBedanktpagina+NL&utm_medium=TicketsBedanktpagina+NL&utm_campaign=TicketsBedanktpagina+NL&utm_id=TicketsBedanktpagina+NL&utm_term=TicketsBedanktpagina+NL&utm_content=TicketsBedanktpagina+NL',
        en: '/en/see-and-do/tickets-for-activities/?utm_source=TicketsBedanktpaginaEN&utm_medium=TicketsBedanktpaginaEN&utm_campaign=TicketsBedanktpaginaEN&utm_id=TicketsBedanktpaginaEN&utm_term=TicketsBedanktpaginaEN&utm_content=TicketsBedanktpaginaEN',
        de: '/de/texel-tipps/tickets/?utm_source=TicketsBedanktpagina+DE&utm_medium=TicketsBedanktpagina+DE&utm_campaign=TicketsBedanktpagina+DE&utm_id=TicketsBedanktpagina+DE&utm_term=TicketsBedanktpagina+DE&utm_content=TicketsBedanktpagina+DE',
    };

    const bikeUrls: Record<Locale, string> = {
        nl: '/nl/zien-en-doen/sportief/fietsen/fiets-huren/?utm_source=FietshurenBedanktpagina+NL&utm_medium=FietshurenBedanktpagina+NL&utm_campaign=FietshurenBedanktpagina+NL&utm_id=FietshurenBedanktpagina+NL&utm_term=FietshurenBedanktpagina+NL&utm_content=FietshurenBedanktpagina+NL',
        en: '/en/see-and-do/outdoor-activities-and-sports/cycling/renting-bikes/?utm_source=FietshurenBedanktpaginaEN&utm_medium=FietshurenBedanktpaginaEN&utm_campaign=FietshurenBedanktpaginaEN&utm_id=FietshurenBedanktpaginaEN&utm_term=FietshurenBedanktpaginaEN&utm_content=FietshurenBedanktpaginaEN',
        de: '/de/texel-tipps/ein-sportlicher-aufenthalt/radfahren/fahrrad-mieten/?utm_source=FietshurenBedanktpaginaDE&utm_medium=FietshurenBedanktpaginaDE&utm_campaign=FietshurenBedanktpaginaDE&utm_id=FietshurenBedanktpaginaDE&utm_term=FietshurenBedanktpaginaDE&utm_content=FietshurenBedanktpaginaDE',
    };

    const { locale } = useRouter();

    const experienceLink = experienceUrls[locale as Locale] ?? experienceUrls.nl;
    const bikeLink = bikeUrls[locale as Locale] ?? bikeUrls.nl;

    return (
        <>
            <Title>
                <FormattedMessage defaultMessage="Heb je hier al aan gedacht?" />
            </Title>
            <StyledFlex justifyContent="space-between" marginTop="2rem" flexDirection={['column', 'row']}>
                <Stack flex="1" style={{ marginRight: '1rem' }}>
                    <StyledBox>
                        <Image src={'/static/img/huur-een-fiets.jpg'} alt="VVV Texel" fill objectFit="cover" />
                    </StyledBox>
                    <Box mb={2}>
                        <strong>
                            <FormattedMessage defaultMessage="Huur een fiets op Texel" />
                        </strong>
                    </Box>
                    <Box>
                        <FormattedMessage defaultMessage="Op de fiets zie je de mooiste plekjes van het eiland. Zorg dat je je huurfiets op tijd regelt. Dat kan voor een dagje of voor je hele verblijf." />
                    </Box>
                    <Box width="25rem" style={{ marginTop: 'auto' }}>
                        <Button
                            as="a"
                            href={bikeLink}
                            size="large"
                            target="_blank"
                            rel="noreferrer noopener"
                            style={{ marginTop: '2rem', marginBottom: '2rem' }}
                        >
                            <FormattedMessage defaultMessage="Huur een fiets" />
                        </Button>
                    </Box>
                </Stack>
                <Stack flex="1" style={{ marginLeft: '1rem' }}>
                    <StyledBox>
                        <Image src={'/static/img/boek-een-belevenis.jpg'} alt="VVV Texel" fill objectFit="cover" />
                    </StyledBox>
                    <Box mb={2}>
                        <strong>
                            <FormattedMessage defaultMessage="Boek een belevenis op Texel" />
                        </strong>
                    </Box>
                    <Box width="100%">
                        <FormattedMessage defaultMessage="Bierproeven, varen op de Waddenzee of wandelen met een natuurgids? Kies uit tientallen excursies, activiteiten en evenementen. Boek op tijd want vol is vol!" />
                    </Box>
                    <Box width="25rem" style={{ marginTop: 'auto' }}>
                        <Button
                            as="a"
                            href={experienceLink}
                            size="large"
                            target="_blank"
                            rel="noreferrer noopener"
                            style={{ marginTop: '2rem', marginBottom: '2rem' }}
                        >
                            <FormattedMessage defaultMessage="Boek een belevenis" />
                        </Button>
                    </Box>
                </Stack>
            </StyledFlex>
        </>
    );
};

export default ConfirmExtras;

const StyledFlex = styled(Flex)`
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        flex-direction: row;
    }
`;

const StyledBox = styled(Box)`
    position: relative;
    height: 20vh;
    width: 100%;
    margin-bottom: 1rem;

    @media screen and (max-width: ${({ theme }) => theme.mediaQueries.m}) {
        height: 40vh;
    }
`;
